import { PaymentMethod } from '@/core/payment-methods/interfaces';
import { PAYMENT_METHOD_ID } from '@/core/payment-methods/constants';
import {
    APPLE_PAY,
    BANCOMAT_PAY,
    BANCONTACT_QR_CODE,
    BIT_PAY,
    BLIK,
    BLIK_DIRECT,
    BLUE_CODE,
    CASH,
    CLICK_TO_PAY,
    CREDIT_CARD,
    DIAS,
    DIRECT_DEBIT,
    DIRECT_PAY,
    EPS,
    GIRO_PAY,
    GIRO_PAY_DIRECT,
    GOOGLE_PAY,
    IDEAL,
    IRIS,
    KLARNA,
    MOBILE_PAY,
    MULTIBANCO,
    MULTIBANCO_REFERENCE,
    MULTIBANCO_WAY,
    P24,
    PAY_ON_DELIVERY,
    PAY_PAL,
    PAYCONIQ,
    PAYMENT_INITIATION,
    PAYU,
    SAMSUNG_PAY,
    SATISPAY,
    SWISH,
    TBI_BNPL,
    TRUSTLY,
    WALLET,
    WE_CHAT_PAY,
    WERO
} from '@/core/payment-methods/constants/methods';

export const PAYMENT_METHOD_WHITELIST: Array<PaymentMethod> = [
    APPLE_PAY,
    BANCOMAT_PAY,
    BANCONTACT_QR_CODE,
    BIT_PAY,
    BLIK,
    BLIK_DIRECT,
    BLUE_CODE,
    CASH,
    CREDIT_CARD,
    CLICK_TO_PAY,
    DIAS,
    DIRECT_DEBIT,
    DIRECT_PAY,
    EPS,
    GIRO_PAY,
    GIRO_PAY_DIRECT,
    GOOGLE_PAY,
    IDEAL,
    IRIS,
    KLARNA,
    MOBILE_PAY,
    MULTIBANCO,
    MULTIBANCO_REFERENCE,
    MULTIBANCO_WAY,
    P24,
    PAY_PAL,
    PAYCONIQ,
    PAYMENT_INITIATION,
    PAY_ON_DELIVERY,
    PAYU,
    SAMSUNG_PAY,
    SATISPAY,
    SWISH,
    TBI_BNPL,
    TRUSTLY,
    WALLET,
    WE_CHAT_PAY,
    WERO
];

export const DEFAULT_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.ClickToPay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.BancomatPay,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.Swish,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const FORCE_REDIRECT_PAYMENT_METHODS: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.MobilePay
];
